import { grey } from '@material-ui/core/colors';

export const itemBackground = grey['200'];
export const subText = grey['600'];

export const graphColorsPalette = [
  '#607D8B',
  '#8BC34A',
  '#FFC107',
  '#3F51B5',
  '#4CAF50',
  '#00BCD4',
  '#FF5722',
  '#2196F3',
  '#9C27B0',
  '#f44336',
  '#009688',
  '#795548',
  '#FF9800',
  '#03A9F4',
  '#E91E63',
  '#673AB7',
  '#9E9E9E',
];

export const sidebarBackground = '#F5F6F7';
